import { call, delay, put, select, takeLatest } from 'typed-redux-saga'
import { NotifyNS, notifySelector, notifySlice, errorHandler } from 'Modules'

function* showNotifySaga(action: NotifyNS.ShowNotify) {
	try {
		const notify = yield* select(notifySelector.getNotification)
		if (notify) {
			yield* put(notifySlice.actions.removeNotify())
			// TODO: если будем переписывть на массив уведомлений, избавиться от delay чтобы анимация работала как раньше
			yield* delay(100)
		}
		yield* put(notifySlice.actions.setNotify({ title: action.payload.title }))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* notifySaga() {
	yield* takeLatest(notifySlice.actions.showNotify.type, showNotifySaga)
}
